import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

// Busca o perfil do coach pelo ID do utilizador autenticado
export async function buscarPerfil(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
  if (error) { console.error(error); return null; }
  return data;
}

// Cria um novo utilizador via Supabase Auth + regista o perfil
// Nota: requer service_role key no backend. Em alternativa, usar o painel do Supabase.
export async function criarPerfil(nome, email, senha) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password: senha,
    options: {
      data: { nome, role: 'coach' }
    }
  });
  if (error) return { error: error.message };
  if (!data.user) return { error: 'Utilizador não criado.' };

  const { error: profileError } = await supabase.from('profiles').insert({
    id: data.user.id,
    nome,
    email,
    role: 'coach',
    avatar: nome.split(' ').map(function(p){ return p[0]; }).join('').slice(0,2).toUpperCase()
  });
  if (profileError) return { error: profileError.message };
  return { success: true };
}

export async function criarLink(token, professorId, professorNome, alunoNome) {
  const { data, error } = await supabase.from('public_links').insert({ token, professor_id: professorId, professor_nome: professorNome, aluno_nome: alunoNome, tipo: 'personalizado' }).select().single();
  if (error) { console.error(error); return null; }
  return data;
}

export async function criarLinkUniversal(token, professorId, professorNome) {
  const { data, error } = await supabase.from('public_links').insert({ token, professor_id: professorId, professor_nome: professorNome, aluno_nome: '__universal__', tipo: 'universal', is_active: true }).select().single();
  if (error) { console.error(error); return null; }
  return data;
}

export async function buscarLink(token) {
  const { data, error } = await supabase.from('public_links').select('*').eq('token', token).eq('is_active', true).single();
  if (error) return null;
  return data;
}

export async function listarLinks(professorId) {
  const { data, error } = await supabase.from('public_links').select('*').eq('professor_id', professorId).order('created_at', { ascending: false });
  if (error) return [];
  return data;
}

export async function desativarLink(token) {
  await supabase.from('public_links').update({ is_active: false }).eq('token', token);
}

export async function salvarResposta(linkId, professorId, alunoNome, scores, media, classificacao, extra) {
  var campos = { link_id: linkId, professor_id: professorId, aluno_nome: alunoNome, scores_json: scores, media_geral: media, classificacao };
  if (extra) {
    if (extra.email) campos.aluno_email = extra.email;
    if (extra.whatsapp) campos.aluno_whatsapp = extra.whatsapp;
    if (extra.idade) campos.aluno_idade = extra.idade;
  }
  const { data, error } = await supabase.from('avaliacoes_respostas').insert(campos).select().single();
  if (error) { console.error(error); return null; }
  return data;
}

export async function listarRespostas(professorId) {
  const { data, error } = await supabase.from('avaliacoes_respostas').select('*').eq('professor_id', professorId).order('created_at', { ascending: false });
  if (error) return [];
  return data;
}

export async function uploadFotoPerfil(userId, file) {
  var ext = file.name.split('.').pop();
  var path = userId + '/avatar.' + ext;
  var { error } = await supabase.storage.from('avatars').upload(path, file, { upsert: true });
  if (error) { console.error(error); return null; }
  var { data } = supabase.storage.from('avatars').getPublicUrl(path);
  return data.publicUrl + '?t=' + Date.now();
}

export async function atualizarPerfil(userId, campos) {
  var { error } = await supabase.from('profiles').update(campos).eq('id', userId);
  if (error) { console.error(error); return false; }
  return true;
}

export async function apagarResposta(id) {
  var { error } = await supabase.from('avaliacoes_respostas').delete().eq('id', id);
  if (error) { console.error(error); return false; }
  return true;
}

export async function apagarLink(token) {
  var { error } = await supabase.from('public_links').delete().eq('token', token);
  if (error) { console.error(error); return false; }
  return true;
}

export async function notificarCoach(coachEmail, coachNome, alunoNome, media, classificacao, scores) {
  try {
    await supabase.functions.invoke("notificar-coach", {
      body: { coachEmail, coachNome, alunoNome, media, classificacao, scores }
    });
  } catch(e) {
    console.error("Erro ao notificar coach:", e);
  }
}

export async function criarCheckout(userId, email) {
  try {
    var { data, error } = await supabase.functions.invoke("criar-checkout", {
      body: {
        priceId: process.env.REACT_APP_STRIPE_PRICE_ID,
        userId,
        email,
        successUrl: window.location.origin + "?upgrade=success",
        cancelUrl: window.location.origin + "?upgrade=cancel",
      }
    });
    if (error) throw error;
    if (data && data.url) window.location.href = data.url;
  } catch(e) {
    console.error("Erro ao criar checkout:", e);
  }
}

export async function contarDiagnosticosMes(professorId) {
  var mesAtual = new Date().toISOString().slice(0, 7); // "2026-05"
  var { data, error } = await supabase
    .from('avaliacoes_respostas')
    .select('id', { count: 'exact' })
    .eq('professor_id', professorId)
    .gte('created_at', mesAtual + '-01');
  if (error) return 0;
  return data ? data.length : 0;
}
